var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_84)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8 8C8 5.23858 10.2386 3 13 3H21C23.7614 3 26 5.23858 26 8V16C26 18.7614 23.7614 21 21 21H13C10.2386 21 8 18.7614 8 16V8Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 12C4.00004 9.23858 6.23861 7 9.00004 7H17C19.7615 7 22 9.23858 22 12V20C22 22.7614 19.7615 25 17 25H9.00004C6.23861 25 4.00004 22.7614 4.00004 20V12Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a4494299e3bd587d40fc3c5aff959b86.svg";
export { ForwardRef as ReactComponent };